import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export interface GetRecipientRaceArgs {
  recipient_id: string;
}

export interface GetRecipientRaceResponse {
  race_display_info: string | null;
}

export const recipientRaceApi = createApi({
  reducerPath: 'recipientRaceApi',
  tagTypes: ['RecipientRace'],
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getRecipientRace: builder.query<GetRecipientRaceResponse, GetRecipientRaceArgs>({
      query: ({ recipient_id }) => ({
        url: `/admin/recipients/${recipient_id}/current-race`,
        method: 'GET',
      }),
      providesTags: (result, error, { recipient_id }) => [
        { type: 'RecipientRace', id: recipient_id },
      ],
    }),
  }),
});

export const { useGetRecipientRaceQuery, useLazyGetRecipientRaceQuery } = recipientRaceApi;
